<template>
  <d2-container>
    <template slot="header">
      <el-form
        :inline="true"
        :model="searchForm"
        ref="searchForm"
        size="mini"
        style="margin-bottom: -18px;"
      >
        <el-form-item
                label="商家名称"
        >
          <el-input
                  v-model="searchForm.agentnamenew"
                  placeholder="商家名称"
                  style="width: 100px;"
          />
        </el-form-item>
        <el-form-item
          label="商品名称"
        >
          <el-input
            v-model="searchForm.agentname"
            placeholder="商品名称"
            style="width: 100px;"
          />
        </el-form-item>
        <el-form-item
                label="订单号"
        >
          <el-input
                  v-model="searchForm.order_id"
                  placeholder="订单号"
                  style="width: 100px;"
          />
        </el-form-item>
        <el-form-item>
          <el-date-picker
                  v-model="dateRange"
                  :picker-options="pickerOptions"
                  type="daterange"
                  range-separator="~"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"    width="150">

          </el-date-picker>

        </el-form-item>

        <el-form-item>
          <el-select
                  class="filter-item"
                  v-model="searchForm.stat"
                  placeholder="状态"
                  width="50"
          >
            <el-option
                    v-for="item in typeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>



        <el-form-item>
          <el-button
            type="primary"
            @click="handleSearchFormSubmit"
          >
            <d2-icon name="search" /> 查询
          </el-button>
        </el-form-item>

        <el-form-item>
          <el-button @click="handleSearchFormReset">
            <d2-icon name="refresh" /> 重置
          </el-button>
        </el-form-item>
      </el-form>
    </template>

    <el-table
      :data="tableData"
      v-loading="loading"
      size="small"
      stripe
      highlight-current-row
      style="width: 100%;"
      @selection-change="handleSelectionChange"
      @sort-change="handleSortChange"
    >

      <el-table-column
        type="selection"
        width="55"
      >
      </el-table-column>
      <el-table-column
        label="商铺名称"
      >
        <template slot-scope="scope">
          {{scope.row.agent_name}}
        </template>
      </el-table-column>

      <el-table-column
        label="商家LOGO"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.agent_logo!=null && scope.row.agent_logo!=''">
            <img :src= "getImgUrl(scope.row)" style="width: 100px;height: 100px; "/>
          </div>

        </template>
      </el-table-column>
      <el-table-column
        label="价格(元)"
      >
        <template slot-scope="scope">
          {{scope.row.amount}}
        </template>
      </el-table-column>
      <el-table-column
              label="订单号"
      >
        <template slot-scope="scope">
          {{scope.row.order_id}}
        </template>
      </el-table-column>
      <el-table-column
              label="下单时间"
      >
        <template slot-scope="scope">
          {{scope.row.insert_times}}
        </template>
      </el-table-column>
      <!--
      <el-table-column
              label="拼团结束时间"
      >
        <template slot-scope="scope">
          {{scope.row.end_times}}
        </template>
      </el-table-column>
      <el-table-column
              label="拼团完成时间"
      >
        <template slot-scope="scope">
          {{scope.row.complete_times}}
        </template>
      </el-table-column>
      -->
      <el-table-column
              label="状态"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.is_pt=='0'">
          <div v-if="scope.row.stat=='0'">
            拼团中
          </div>
          <div v-else-if="scope.row.stat=='1'">
            拼团成功
          </div>
          <div v-else-if="scope.row.stat=='2'">
            拼团失败
          </div>
          </div>
          <div v-else-if="scope.row.is_pt=='1'">
            <div v-if="scope.row.stat=='0'">
              待支付
            </div>
            <div v-else-if="scope.row.stat=='1'">
              购买成功
            </div>
            <div v-else-if="scope.row.stat=='2'">
              购买失败
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
              label="商家地址"
      >
        <template slot-scope="scope">
          {{scope.row.agent_adress}}
        </template>
      </el-table-column>
      <el-table-column
              label="商品图片"
      >

        <template slot-scope="scope">
          <div v-if="scope.row.good_url!=null && scope.row.good_url!=''">


            <span v-for="(item,index) in scope.row.good_url.split(',')">
              <span v-if="index==0">
                 <span v-if="item.indexOf('mp4') !=-1">
              <video
                      v-bind:src="getImgUrl2(scope.row)"
                      class="avatar video-avatar"
                      controls="controls"  style="width: 200px;height: 100px; "></video>
              </span>
              <span v-else>
                 <img :src= "getImgUrl2(scope.row)" style="width: 200px;height: 100px; "/>
              </span>
              </span>
          </span>



          </div>

        </template>
      </el-table-column>
      <el-table-column
              label="商品名称"
      >
        <template slot-scope="scope">
          {{scope.row.good_name}}
        </template>
      </el-table-column>
      <el-table-column
              label="发起人"
      >
        <template slot-scope="scope">
          {{scope.row.sponsor_wx}}
        </template>
      </el-table-column>
      <el-table-column
              label="发起人微信头像"
      >
        <template slot-scope="scope">


          <div v-if="scope.row.sponsor_img_url!=null && scope.row.sponsor_img_url!=''">
            <img :src= "getImgUrl3(scope.row)" style="width: 100px;height: 100px; "/>
          </div>

        </template>
      </el-table-column>
      <!--
      <el-table-column
            label="拼团人数"
    >
      <template slot-scope="scope">
        {{scope.row.group_num}}
      </template>
    </el-table-column>
      <el-table-column
              label="拼团成功数量"
      >
        <template slot-scope="scope">
          {{scope.row.group_success_num}}
        </template>
      </el-table-column>
      <el-table-column
              label="抱团未成功补贴(%)"
      >
        <template slot-scope="scope">
          {{scope.row.group_subsidy}}
        </template>
      </el-table-column>
-->

      <el-table-column
        fixed="right"
        label="操作"
        align="center"
        width="150"
      >
        <template slot-scope="scope">
          <el-button type="primary" plain size="mini"   @click="openViewForm(scope.row)">查看信息</el-button>
        </template>
      </el-table-column>

    </el-table>
    <template slot="footer">
      <el-pagination
        :current-page="page.current"
        :page-size="page.size"
        :total="page.total"
        :page-sizes="[1,10,50,100, 200, 300, 400]"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: -10px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </template>
    <view-form
            :oneclass="oneclass"
            v-model="viewFormVisible"
            @submit="getTableData"
    />

    <tk-form
            :oneclass="oneclass"
            v-model="tkFormVisible"
            @submit="getTableData"
    />

  </d2-container>
</template>
<script>
import * as memberService from "@/api/sys/member";
import * as agentService from "@/api/sys/agent";
import util from '@/libs/util.js'
import viewForm from "./viewForm";
import tkForm from "./tkForm";
export default {
  name: "MembergglPage",
  components: {viewForm,tkForm },
  data() {
    return {
      searchForm: {
          fxtel: "",
          legal: "",
          userCode: ""
      },
      loading: false,
      tableData: [],
      multipleSelection: [],
        dateRange: [],
        pickerOptions:{},
        typeOptions: [

            {
                value: "0",
                label: "拼团中"
            },
          {
            value: "1",
            label: "拼团成功"
          }, {
            value: "2",
            label: "拼团失败"
          }
        ],



      page: {
        current: 1,
        size: 10,
        total: 0
      },
      sort: {
        prop: "",
        order: ""
      },
        oneclass: {},
        agentid:'',
      tkFormVisible: false,
        viewFormVisible: false
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
      dateConversion(value) {
          if (value != null && value != "") {
              var d = new Date(value);
              //  var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();
              var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
              console.info("===========date=========" + date);
              return date;
          }else{
              return "";
          }
      },
      getImgUrl(row){
          return "https://hfqy-1315629620.cos.ap-chengdu.myqcloud.com/"+row.agent_logo;
      },
    getImgUrl2(row){
        var good_url=row.good_url;
      if(good_url.match(",")){
        var str = good_url.split(',');
        good_url=str[0];
      }

      return "https://hfqy-1315629620.cos.ap-chengdu.myqcloud.com/"+good_url;
    },
    getImgUrl3(row){
      var good_url=row.sponsor_img_url;
      if(good_url.match(",")){
        var str = good_url.split(',');
        good_url=str[1];
      }

      return good_url;
    },
    getTableData() {
      let query = {
        pageIndex: this.page.current,
        pageSize: this.page.size,
        sortBy: this.sort.prop,
          dl_type: util.cookies.get('dl_type'),
          xt_id: util.cookies.get('xt_id'),
          agentid: util.cookies.get('agentid'),
        start_time:this.dateConversion(this.dateRange[0]),
        end_time:this.dateConversion(this.dateRange[1]),
        descending: this.sort.order === "descending",
        filter: this.searchForm
      };
      agentService.myGrouporderlist(query).then(data => {
        this.tableData = data.rows;
        this.page.total = data.totalCount;
      });
    },
    handleSearchFormSubmit() {
      this.getTableData();
    },
    handleSearchFormReset() {
      this.$refs.searchForm.resetFields();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSortChange(val) {
      this.sort.prop = val.prop;
      this.sort.order = val.order;
      this.getTableData();
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.page.current = val;
      this.getTableData();
    },
      openViewForm(oneclass) {
          this.oneclass = oneclass;
          this.viewFormVisible = true;
        this.tkFormVisible = false;
      },

    openTkForm(oneclass) {
      this.oneclass = oneclass;
      this.viewFormVisible = false;
      this.tkFormVisible = true;
    },
    batchDel() {
      this.$confirm("确认删除？", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "删除",
        cancelButtonText: "取消"
      }).then(() => {
          memberService
          .delCommentBath({
            ids: JSON.stringify(this.multipleSelection.map(s => s.id))
          })
          .then(() => {
            this.getTableData();
          });
      });
    },
    qrsh(oneclass) {
          let msg ="收货";
          this.$confirm("确认"+msg+"操作？", "确认信息", {
              distinguishCancelAndClose: true,
              confirmButtonText: msg,
              cancelButtonText: "取消"
          }).then(() => {
            agentService.qrIntegral({order_id:oneclass.order_id}).then(() => {
                  this.getTableData();
              });
          });
      },
    del(oneclass) {
      this.$confirm("确认删除？", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "删除",
        cancelButtonText: "取消"
      }).then(() => {
        agentService.delIntegral({id:oneclass.id}).then(() => {
          this.getTableData();
        });
      });
    }
  }
};
</script>
